import CSQCAxios from '@/outils/CSQCAxios';

const CONTROLLER_NAME = 'Faq';
export default {
  clearCache: false,
  ObtenirFaq() {
    return CSQCAxios.getAxios().get(`${CONTROLLER_NAME}`);
  },
};
